const Menu =[{
    id: 1,
    ims: "ims",
    image: "images/aot1.jpg",
    name: "aot",
    category: "aot",
    discription: "1080 X 2034",
},

{
    id: 2,
    ims: "ims",
    image: "images/aot2.jpg",
    name: "aot",
    category: "aot",
    discription: "1080 X 2034",
},


{
    id: 3,
    ims: "ims",
    image: "images/aot3.jpg",
    name: "aot",
    category: "aot",
    discription: "1080 X 2034",
},


{
    id: 4,
    ims: "ims",
    image: "images/Naruto1.jpg",
    name: "Naruto",
    category: "Naruto",
    discription: "1080 X 2034",
},


{
    id: 5,
    ims: "ims",
    image: "images/Naruto2.jpg",
    name: "Naruto",
    category: "Naruto",
    discription: "1080 X 2034",
},
{
    id: 6,
    ims: "ims",
    image: "images/Naruto3.jpg",
    name: "Naruto",
    category: "Naruto",
    discription: "1080 X 2034",
},
{
    id: 7,
    ims: "ims",
    image: "images/Naruto4.jpg",
    name: "Naruto",
    category: "Naruto",
    discription: "1080 X 2034",
},
{
    id: 8,
    ims: "ims",
    image: "images/bleach1.jpg",
    name: "bleach",
    category: "bleach",
    discription: "1080 X 2034",
},
{
    id: 9,
    ims: "ims",
    image: "images/bleach2.jpg",
    name: "bleach",
    category: "bleach",
    discription: "1080 X 2034",
},
{
    id: 10,
    ims: "ims",
    image: "images/bleach3.jpg",
    name: "bleach",
    category: "bleach",
    discription: "1080 X 2034",
},

{
    id: 11,
    ims: "ims",
    image: "images/db1.jpg",
    name: "Dragon Ball",
    category: "Dragon Ball",
    discription: "1080 X 2034",
},
{
    id: 12,
    ims: "ims",
    image: "images/db2.jpg",
    name: "Dragon Ball",
    category: "Dragon Ball",
    discription: "1080 X 2034",
},
{
    id: 13,
    ims: "ims",
    image: "images/db3.jpg",
    name: "Dragon Ball",
    category: "Dragon Ball",
    discription: "1080 X 2034",
},

{
    id: 14,
    ims: "ims",
    image: "images/deathNote1.jpg",
    name: "Death Note",
    category: "Death Note",
    discription: "1080 X 2034",
},

{
    id: 15,
    ims: "ims",
    image: "images/deathNote2.jpg",
    name: "Death Note",
    category: "Death Note",
    discription: "1080 X 2034",
},

{
    id: 16,
    ims: "ims",
    image: "images/deathNote3.jpg",
    name: "Death Note",
    category: "Death Note",
    discription: "1080 X 2034",
},

{
    id: 17,
    ims: "ims",
    image: "images/deathNote4.jpg",
    name: "Death Note",
    category: "Death Note",
    discription: "1080 X 2034",
},

{
    id: 18,
    ims: "ims",
    image: "images/jk1.jpg",
    name: "Jujutsu Kaison",
    category: "Jujutsu Kaison",
    discription: "1080 X 2034",
},

{
    id: 19,
    ims: "ims",
    image: "images/jk2.jpg",
    name: "Jujutsu Kaison",
    category: "Jujutsu Kaison",
    discription: "1080 X 2034",
},
{
    id: 20,
    ims: "ims",
    image: "images/jk3.jpg",
    name: "Jujutsu Kaison",
    category: "Jujutsu Kaison",
    discription: "1080 X 2034",
},
{
    id: 21,
    ims: "ims",
    image: "images/onePiece1.jpg",
    name: "One Piece",
    category: "One Piece",
    discription: "1080 X 2034",
},
{
    id: 22,
    ims: "ims",
    image: "images/onePiece2.jpg",
    name: "One Piece",
    category: "One Piece",
    discription: "1080 X 2034",
},
{
    id: 23,
    ims: "ims",
    image: "images/onePiece3.jpg",
    name: "One Piece",
    category: "One Piece",
    discription: "1080 X 2034",
},
{
    id: 24,
    ims: "ims",
    image: "images/onePiece4.png",
    name: "One Piece",
    category: "One Piece",
    discription: "1080 X 2034",
},
{
    id: 25,
    ims: "ims",
    image: "images/onePiece5.jpeg",
    name: "One Piece",
    category: "One Piece",
    discription: "1080 X 2034",
},
{
    id: 26,
    ims: "ims",
    image: "images/onePiece6.jpg",
    name: "One Piece",
    category: "One Piece",
    discription: "1080 X 2034",
},
{
    id: 27,
    ims: "ims",
    image: "images/onePiece7.jpg",
    name: "One Piece",
    category: "One Piece",
    discription: "1080 X 2034",
},

{
    id: 28,
    ims: "ims",
    image: "images/aot4.jpg",
    name: "aot",
    category: "aot",
    discription: "1080 X 2034",
},

{
    id: 29,
    ims: "ims",
    image: "images/aot5.png",
    name: "aot",
    category: "aot",
    discription: "1080 X 2034",
},

{
    id: 30,
    ims: "ims",
    image: "images/aot6.jpg",
    name: "aot",
    category: "aot",
    discription: "1080 X 2034",
},

{
    id: 31,
    ims: "ims",
    image: "images/aot7.jpg",
    name: "aot",
    category: "aot",
    discription: "1080 X 2034",
},

{
    id: 32,
    ims: "ims",
    image: "images/bleach4.jpg",
    name: "bleach",
    category: "bleach",
    discription: "1080 X 2034",
},

{
    id: 33,
    ims: "ims",
    image: "images/bleach5.jpg",
    name: "bleach",
    category: "bleach",
    discription: "1080 X 2034",
},

{
    id: 34,
    ims: "ims",
    image: "images/bleach6.jpeg",
    name: "bleach",
    category: "bleach",
    discription: "1080 X 2034",
},

{
    id: 35,
    ims: "ims",
    image: "images/bleach7.jpg",
    name: "bleach",
    category: "bleach",
    discription: "1080 X 2034",
},

{
    id: 36,
    ims: "ims",
    image: "images/Naruto5.jpeg",
    name: "Naruto",
    category: "Naruto",
    discription: "1080 X 2034",
},

{
    id: 37,
    ims: "ims",
    image: "images/Naruto6.jpg",
    name: "Naruto",
    category: "Naruto",
    discription: "1080 X 2034",
},

{
    id: 38,
    ims: "ims",
    image: "images/Naruto7.jpg",
    name: "Naruto",
    category: "Naruto",
    discription: "1080 X 2034",
},

{
    id: 39,
    ims: "ims",
    image: "images/Naruto8.jpg",
    name: "Naruto",
    category: "Naruto",
    discription: "1080 X 2034",
},

{
    id: 40,
    ims: "ims",
    image: "images/db4.jpg",
    name: "Dragon Ball",
    category: "Dragon Ball",
    discription: "1080 X 2034",
},

{
    id: 41,
    ims: "ims",
    image: "images/db5.jpg",
    name: "Dragon Ball",
    category: "Dragon Ball",
    discription: "1080 X 2034",
},

{
    id: 42,
    ims: "ims",
    image: "images/db6.jpg",
    name: "Dragon Ball",
    category: "Dragon Ball",
    discription: "1080 X 2034",
},


{
    id: 43,
    ims: "ims",
    image: "images/db7.jpg",
    name: "Dragon Ball",
    category: "Dragon Ball",
    discription: "1080 X 2034",
},

{
    id: 44,
    ims: "ims",
    image: "images/jk4.jpg",
    name: "Jujutsu Kaison",
    category: "Jujutsu Kaison",
    discription: "1080 X 2034",
},

{
    id: 45,
    ims: "ims",
    image: "images/jk5.jpg",
    name: "Jujutsu Kaison",
    category: "Jujutsu Kaison",
    discription: "1080 X 2034",
},

];

export default Menu;